<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout column class="datatable" :class="{'hide-separator': !separator}">
        <v-data-table
                :class="{ overflowYVisible, overflowXScrollVisible, 'fixed-select': fixedSelect, 'fixed-select-not-hide': !hideSelectWhenFixed}"
                :mobile-breakpoint="0"
                :footer-props="footerProps"
                :headers="headers"
                :items="items"
                :page.sync="pagination.page"
                :server-items-length.sync="pagination.totalItems"
                :items-per-page.sync="pagination.rowsPerPage"
                :sort-by.sync="pagination.sortBy"
                :sort-desc.sync="pagination.descending"
                :hide-default-footer="hideFooter"
                v-bind="$attrs"
                :show-select="showSelect"
                :disable-select="disableSelect"
                :item-key="itemKey"
                v-model="selected"
                @pagination="reload"
                :multi-sort="false"
                :must-sort="true">
            <!-- Se o componente pai declarou o slot 'items' -->
            <template v-if="$scopedSlots.items" v-slot:item="{item, index}">
                <tr :class="{ 'tr-color': coloredRow}" @click="$emit('rowSelected', item)">
                    <!-- Slot do checkbox de cada row -->
                    <td v-if="showSelect">
                        <v-checkbox
                                color="accent"
                                :value="item"
                                v-model="selected"
                                :disabled="shouldDisableSelect && shouldDisableSelect(item)"
                                hide-details />
                    </td>
                    <!-- Slot dos dados de cada row <td> {{texto}} </td> -->
                    <slot name="items" v-bind="{item, index}" />
                </tr>
            </template>

            <!-- Senão, cria slots dinâmicos baseados nos headers -->
            <template v-else v-for="h in headers"
                      v-slot:[`item.${h.value}`]="{item}">
                <slot :name="`item.${h.value}`" v-bind="item" />
            </template>

            <template class="carregando" v-if="$scopedSlots.header" v-slot:header="header">
                <slot name="header" v-bind="header" />
            </template>

            <!-- TOTAL-->
            <!-- Atenção: As "keys", precisam estar ordenadas na ordem de que ficará na tela para o calculo funcionar. -->
            <tr v-if="showTotal && items.length" slot="body.append">
                <td class="label-total" v-for="item in headers" :key="item.value">
                    {{ checkTotal(item.value, items, cellTotal) }}
                </td>
            </tr>

            <v-layout class="carregando justify-center align-center" slot="footer" v-show="loading">
                <v-progress-circular class="ma-2" color="primary" :size="18" :width="2"
                                     indeterminate />
                Carregando...
            </v-layout>
        </v-data-table>
        <div class="overlay" v-show="loading"></div>
    </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import { debounce, get, isEqual } from 'lodash'
  import { notification } from '../plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    props: {
      url: String,
      params: Object,

      headers: Array,
      filter: Object,
      infoCards: Boolean,
      itemKey: String,
      showSelect: Boolean,
      disableSelect: Boolean,
      separator: Boolean,
      hideFooter: Boolean,
      showTotal: Boolean,
      cellTotal: Array,
      shouldDisableSelect: Function,
      coloredRow: {
        type: Boolean,
        default: false
      },
      silent: {
        type: Boolean,
        default: false
      },
      disableItemsPerPage: {
        type: Boolean,
        default: false
      },
      overflowYVisible: {
        type: Boolean,
        default: false
      },
      overflowXScrollVisible: {
        type: Boolean,
        default: false
      },
      hideSelectWhenFixed: {
        type: Boolean,
        default: true
      },
      fixedSelect: {
        type: Boolean,
        default: false
      },
      value: Array
    },
    data: () => ({
      loading: false,
      pagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 12,
        items_grid: 12,
        sortBy: '',
        descending: false
      },
      items: [],
      selected: []
    }),
    computed: {
      ...mapState([ 'id_unidade_negocio', 'id_comissionado_venda' ]),
      footerProps () {
        return {
          'items-per-page-options': [this.pagination.items_grid, 25, 50],
          'disable-items-per-page': this.disableItemsPerPage
        }
      }
    },
    watch: {
      filter () {
        if (!this.pagination.keep_pagination) {
          this.pagination.page = 1
        }
        this.reload()
      },
      selected () {
        this.$emit('input', this.selected)
      },
      params () {
        const oldKeepPagination = this._oldKeepPagination
        const newKeepPagination = this.pagination.keep_pagination

        if (!isEqual(oldKeepPagination, newKeepPagination)) {
          if (!newKeepPagination) {
            this.pagination.page = 1
          }
          this.reload()
          this._oldKeepPagination = newKeepPagination
        }
      },
      pagination (newValue) {
        if (this.pagination.keep_pagination !== false && !newValue.firstPagination) {
          this.pagination.keep_pagination = false
        }
        this.$emit('pagination', this.pagination)
      },
      id_unidade_negocio () {
        this.reload()
      },
      id_comissionado_venda () {
        this.reload()
      },
      value (val) {
        this.selected = val
      }
    },
    mounted () {
      const externalPagination = get(this.params, 'pagination', {})
      this.pagination = { ...this.pagination, ...externalPagination, firstPagination: true }
      if (this.showSelect && !this.itemKey) {
        console.error('Prop item-key is required for select-all')
      }
    },
    methods: {
      // debounce evita varias requisicoes seguidas
      reload: debounce(function (silent = false) {
        this.$http.cancel(this._uid)
        this.loading = true
        this.$emit('filter')
        return this.$http.get(this.url, {
          requestId: this._uid,
          params: {
            id_unidade_negocio: this.id_unidade_negocio,
            ...this.params,
            pagination: this.pagination,
            filter: this.filter,
            id_comissionado: this.id_comissionado_venda
          },
          options: { silent: (silent === true) || (this.silent === true) }
        }).then((res) => {
          this.selected = []
          this.items = []
          this.$nextTick(() => {
            this.items = res.data.items
            this.pagination.totalItems = res.data.total
            this.pagination.keep_pagination = false
            this.$emit('onLoad', res.data.items)
          })
        }).catch((err) => {
          if (err?.response?.data?.Codigo_Erro === -1) {
            this.resetDataTable()
            notification(AlertTypes.ERROR, err?.response?.data?.Msg_Erro)
          }
        }).finally(() => (
          this.loading = false
        ))
      }, 10),
      resetDataTable () {
        this.selected = []
        this.items = []
        this.$nextTick(() => {
          this.pagination.totalItems = 0
          this.$emit('onLoad', [])
        })
      },
      checkTotal (key, items, cellTotal = []) {
        if (key && Array.isArray(cellTotal) && cellTotal.includes(key)) {
          return 'TOTAL: ' + items.map((item) => item[key]).reduce((a, b) => a + b, 0)
        }
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>
    .datatable {
        position: relative;
        z-index: 1;
    }

    .carregando {
        position: absolute;
        bottom: 15px;
        z-index: 3;
    }

    .overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 5;
        user-select: none;
        background: #b8b8b81d;
    }
</style>

<style lang="scss">
    .v-simple-checkbox {
        .mdi-minus-box, .mdi-checkbox-marked {
            color: var(--accent);
        }
    }

    .datatable {
        .v-input--checkbox {
            &.v-input--selection-controls,
            .v-input--selection-controls__input {
                margin-top: 0;
                margin-right: 0;
                padding-top: 0.5px;
            }
        }

        &.hide-separator tbody tr {
            &:hover {
                background: none !important;
            }

            &:not(:last-child) {
                border-bottom: none;
                border-top: none;
            }
        }

        // remove o efeito de hover
        .v-input--selection-controls__input {
            .v-input--selection-controls__ripple:before {
                display: none;
            }
        }

        .v-ripple__animation {
            background: var(--accent);
        }
    }
    .label-total {
        color: var(--primary);
        font-weight: 900;
    }
    .fixed-select {
      table > tbody > tr > td:nth-child(1),
      table > thead > tr > th:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        z-index: 9998;
        background: white;
        padding-left: 10px;
      }
      table > thead > tr > th:nth-child(1) {
        z-index: 9999;
      }
    }
  .fixed-select-not-hide {
    table > tbody > tr > td:nth-child(1) {
      z-index: 1;
    }
  }
</style>
